"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var actor_abstract_path_1 = require("@comunica/actor-abstract-path");

var bus_query_operation_1 = require("@comunica/bus-query-operation");

var rdf_string_1 = require("rdf-string");

var sparqlalgebrajs_1 = require("sparqlalgebrajs");
/**
 * A comunica Path Seq Query Operation Actor.
 */


var ActorQueryOperationPathSeq =
/*#__PURE__*/
function (_actor_abstract_path_) {
  _inherits(ActorQueryOperationPathSeq, _actor_abstract_path_);

  function ActorQueryOperationPathSeq(args) {
    _classCallCheck(this, ActorQueryOperationPathSeq);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationPathSeq).call(this, args, sparqlalgebrajs_1.Algebra.types.SEQ));
  }

  _createClass(ActorQueryOperationPathSeq, [{
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(path, context) {
        var predicate, blank, blankName, subOperations, join, bindingsStream;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                predicate = path.predicate;
                blank = this.generateBlankNode(path);
                blankName = rdf_string_1.termToString(blank);
                _context.next = 5;
                return Promise.all([this.mediatorQueryOperation.mediate({
                  context: context,
                  operation: actor_abstract_path_1.ActorAbstractPath.FACTORY.createPath(path.subject, predicate.left, blank, path.graph)
                }), this.mediatorQueryOperation.mediate({
                  context: context,
                  operation: actor_abstract_path_1.ActorAbstractPath.FACTORY.createPath(blank, predicate.right, path.object, path.graph)
                })]);

              case 5:
                _context.t0 = function (op) {
                  return bus_query_operation_1.ActorQueryOperation.getSafeBindings(op);
                };

                subOperations = _context.sent.map(_context.t0);
                _context.t1 = bus_query_operation_1.ActorQueryOperation;
                _context.next = 10;
                return this.mediatorJoin.mediate({
                  entries: subOperations
                });

              case 10:
                _context.t2 = _context.sent;
                join = _context.t1.getSafeBindings.call(_context.t1, _context.t2);
                // remove the generated blank nodes from the bindings
                bindingsStream = join.bindingsStream.transform({
                  transform: function transform(item, next) {
                    bindingsStream._push(item.delete(blankName));

                    next(null);
                  }
                });
                return _context.abrupt("return", {
                  type: 'bindings',
                  bindingsStream: bindingsStream,
                  variables: join.variables
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function runOperation(_x, _x2) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }()
  }]);

  return ActorQueryOperationPathSeq;
}(actor_abstract_path_1.ActorAbstractPath);

exports.ActorQueryOperationPathSeq = ActorQueryOperationPathSeq;